export default __webpack_public_path__ + "static/media/CNo.91-5.6ab9735a.jpg";